export const WEEK_SCHEDULE_VIEW_DAYS_LIMIT = 10;
export const WEEK_DAYS_LIMIT = 7;

export const SINGLE_DAY_COL_SPAN = 24;
export const DEFAULT_COL_SPAN = 1